import { Button } from "@mui/material";

const Manutencao = () => { 

    return(
        <div className="container">
            
            <div className="content">
                <div className="maintenance-content">
                    <img className="faixa" src="images/faixa.svg"/>
                    <img className="logo-maintenance" src="images/logobc.svg"/>
                    <div style={{zIndex:1}}>
                        <div className="maintenance-title">EM MANUTENÇÃO</div>
                        <div className="maintenance-subtitle">Nosso site está em construção, estamos trabalhando<br/>muito para lhe proporcionar o melhor atendimento.</div>
                    </div>
                    <div className="maintenance-btns-container">
                        <div>
                            <div className="maintenance-subtitle">Assistência</div>
                            <div style={{marginTop:'10px'}} className="maintenance-btnsLeft">
                                <a href='https://wa.me/+554591084120' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                                    <Button sx={{lineHeight:'1.3', paddingInline:'25px', height:50, borderRadius:'5px', color:'#474747',border:'solid 2px #474747', width:'200px', fontSize:'15px', fontWeight:'bold', backgroundColor:'transparent', textTransform: 'none','&:hover': {color: '#FFF', backgroundColor:'#474747'}}}>Plantão 24h<br/>Cascavel-PR</Button>
                                </a>
                                <a href='https://wa.me/+556599622632' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                                    <Button sx={{lineHeight:'1.3', paddingInline:'25px', height:50, borderRadius:'5px', color:'#474747',border:'solid 2px #474747', width:'200px', fontSize:'15px', fontWeight:'bold', backgroundColor:'transparent', textTransform: 'none','&:hover': {color: '#FFF', backgroundColor:'#474747'}}}>Plantão 24h<br/>Cuiabá-MT</Button>
                                </a>
                            </div>
                        </div>
                        <div>
                            <div className="maintenance-subtitle">Comercial</div>
                            <div style={{marginTop:'10px'}} className="maintenance-btnsRight">
                                <a href='https://wa.me/+554599714611' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                                    <Button sx={{lineHeight:'1.3', paddingInline:'25px', height:50, borderRadius:'5px', color:'#474747',border:'solid 2px #474747', width:'200px', fontSize:'15px', fontWeight:'bold', backgroundColor:'transparent', textTransform: 'none','&:hover': {color: '#FFF', backgroundColor:'#474747'}}}>Sul/Sudeste<br/>Vinicius</Button>
                                </a>
                                <a href='https://wa.me/+556599547518' style={{textDecoration:'none', color:'#000', marginInline:'3px'}}>
                                    <Button sx={{lineHeight:'1.3', paddingInline:'25px', height:50, borderRadius:'5px', color:'#474747',border:'solid 2px #474747', width:'200px', fontSize:'15px', fontWeight:'bold', backgroundColor:'transparent', textTransform: 'none','&:hover': {color: '#FFF', backgroundColor:'#474747'}}}>Norte/Centro-Oeste<br/>Luciano</Button>
                                </a>
                            </div>
                        </div>
                    </div>
                    <img className="cones" src="images/cones.png"/>
                    <div className="background-maintenance"/>
                </div>
                
            </div>
        </div>
    )
}
export default Manutencao;